/* ============================================================
   LP 5 Razões — versão BUNDLES — JS
   IIFE idempotente, escopado na raiz .lp-5razb-wrap.
   - Smooth-scroll dos CTAs (hero + depoimentos + razões) → #lp-bundles
   - Cards de bundle: COMPRAR adiciona N unidades da creatina maçã verde
     (data-variant-id + data-qty) → /cart/add.js → /checkout
   - Countdown opcional (oculto se sem data)
   _lp_source = 'lp-5-razoes-bundles'
   ============================================================ */
(function(){
  function init(root){
    if (!root || root.dataset.lpInit === '1') return;
    root.dataset.lpInit = '1';

    /* ============== SMOOTH-SCROLL CTA → bloco de bundles (#lp-bundles) ============== */
    /* O alvo (#lp-bundles) pode estar em OUTRA section, então busca no document. */
    root.querySelectorAll('[data-lp-scroll-bundles]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        var target = document.getElementById('lp-bundles');
        if (target){ e.preventDefault(); target.scrollIntoView({ behavior:'smooth', block:'start' }); }
      });
    });

    /* ============== CRONÔMETRO DE URGÊNCIA — evergreen (X min por visitante) ============== */
    /* Conta X min a partir da 1ª visita (persistido em localStorage por device).
       Ao zerar, reinicia a janela → sensação de urgência sempre presente. Prioritário sobre o de data fixa. */
    (function(){
      var ev = root.querySelector('[data-countdown-evergreen]');
      if (!ev) return;
      var mins = parseInt(ev.getAttribute('data-countdown-evergreen'), 10);
      if (!mins || mins <= 0){ ev.style.display = 'none'; return; }
      var DURATION = mins * 60 * 1000;
      var KEY = 'lp5razb_urgency_end';
      var elM = ev.querySelector('[data-cd="m"]'), elS = ev.querySelector('[data-cd="s"]');
      function pad(n){ return (n < 10 ? '0' : '') + n; }
      function readEnd(){
        var stored = 0;
        try { stored = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e){}
        // sem janela válida (1ª visita ou já expirou) → abre nova janela de X min
        if (!stored || stored <= Date.now()){
          stored = Date.now() + DURATION;
          try { localStorage.setItem(KEY, String(stored)); } catch (e){}
        }
        return stored;
      }
      var end = readEnd();
      function tick(){
        var diff = end - Date.now();
        if (diff <= 0){ end = readEnd(); diff = end - Date.now(); } // reinicia evergreen
        var s = Math.floor(diff / 1000);
        if (elM) elM.textContent = pad(Math.floor(s / 60));
        if (elS) elS.textContent = pad(s % 60);
      }
      tick();
      setInterval(tick, 1000);
    })();

    /* ============== COUNTDOWN de data fixa (oculto se sem data) ============== */
    (function(){
      var cd = root.querySelector('[data-countdown-end]');
      if (!cd) return;
      var endStr = cd.getAttribute('data-countdown-end');
      var end = endStr ? new Date(endStr.replace(' ', 'T')) : null;
      if (!end || isNaN(end.getTime())){ cd.style.display = 'none'; return; }
      var elD = cd.querySelector('[data-cd="d"]'), elH = cd.querySelector('[data-cd="h"]');
      var elM = cd.querySelector('[data-cd="m"]'), elS = cd.querySelector('[data-cd="s"]');
      function pad(n){ return (n < 10 ? '0' : '') + n; }
      function tick(){
        var diff = end.getTime() - Date.now();
        if (diff <= 0){ cd.style.display = 'none'; clearInterval(timer); return; }
        var s = Math.floor(diff / 1000);
        if (elD) elD.textContent = pad(Math.floor(s / 86400));
        if (elH) elH.textContent = pad(Math.floor((s % 86400) / 3600));
        if (elM) elM.textContent = pad(Math.floor((s % 3600) / 60));
        if (elS) elS.textContent = pad(s % 60);
      }
      tick();
      var timer = setInterval(tick, 1000);
    })();

    /* ============== CARDS DE BUNDLE — COMPRAR (add + checkout numa navegação, sem delay) ==============
       Antes: fetch /cart/add.js (espera o AJAX completar) → /checkout. Esse round-trip dava
       o delay e o "carrinho vazio" que o checkout às vezes carregava antes do add propagar.
       Agora: navega direto pro endpoint GET /cart/add?...&return_to=/checkout — o Shopify
       adiciona o item E redireciona pro checkout numa request só, sem AJAX, sem esperar nada.
       (`return_to` é param nativo do /cart/add, já usado em snippets/back-in-stock.liquid.)
       O `_lp_source` continua atribuído pelo lp-source-tracker.js, que grava como CART ATTRIBUTE
       no load da página (cart → checkout → order nativamente). Mantemos também a line-item
       property como reforço, igual ao fluxo antigo. */
    root.querySelectorAll('[data-offer-add]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var variantId = parseInt(btn.dataset.variantId, 10);
        var qty = parseInt(btn.dataset.qty, 10) || 1;
        if (!variantId) return;
        btn.classList.add('lp-loading');
        // return_to leva pro /checkout já com o cupom PRIMEIRAGUDAY na URL → o Shopify
        // aplica o cupom no checkout automaticamente (o cliente não precisa digitar).
        // O ?discount= vai encodado dentro do return_to (que é ele mesmo um param).
        var url = '/cart/add?id=' + variantId +
          '&quantity=' + qty +
          '&properties[_lp_source]=lp-5-razoes-bundles' +
          '&return_to=' + encodeURIComponent('/checkout?discount=PRIMEIRAGUDAY');
        window.location.href = url;
      });
    });

    /* ============== DEPOIMENTOS — carrossel mobile (bullets + scroll-snap) ============== */
    (function(){
      var track = root.querySelector('[data-lp-testi-track]');
      var dotsWrap = root.querySelector('[data-lp-testi-dots]');
      if (!track || !dotsWrap) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.lp-testi-card'));
      if (cards.length < 2) return;

      // monta os bullets (1 por card)
      var dots = cards.map(function(card, i){
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'lp-testi-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Ver depoimento ' + (i + 1));
        dot.addEventListener('click', function(){
          track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
        return dot;
      });

      // sincroniza o bullet ativo conforme arrasta (card mais centralizado)
      var raf = null;
      function syncActive(){
        raf = null;
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        cards.forEach(function(card, i){
          var c = card.offsetLeft + card.clientWidth / 2;
          var d = Math.abs(c - center);
          if (d < bestDist){ bestDist = d; best = i; }
        });
        dots.forEach(function(dot, i){ dot.classList.toggle('is-active', i === best); });
      }
      track.addEventListener('scroll', function(){
        if (raf) return;
        raf = (window.requestAnimationFrame || window.setTimeout)(syncActive, 16);
      });
    })();

    /* ============== FAQ ACCORDION (embaixo dos bundles) ============== */
    root.querySelectorAll('.lp-b-faq-item').forEach(function(item){
      var q = item.querySelector('.lp-b-faq-q');
      if (!q) return;
      q.addEventListener('click', function(){
        var wasOpen = item.classList.contains('lp-open');
        root.querySelectorAll('.lp-b-faq-item.lp-open').forEach(function(o){ o.classList.remove('lp-open'); });
        if (!wasOpen) item.classList.add('lp-open');
      });
    });
  }

  function boot(){ document.querySelectorAll('.lp-5razb-wrap').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
